import React from 'react';
import { formatDate } from 'shared_items/formatConventions';

const DetailedTransactionCard = (props) => {
  // ###### FORMATTING FUNCTIONS
  const formatValue = (value) => {
    const numValue = parseFloat(value);
    return numValue.toFixed(2);
  };

  const getTypeColor = () => {
    return props.flow.flow_type === 'In' 
      ? 'bg-green-100 text-green-800' 
      : 'bg-red-100 text-red-800';
  };

  const truncateText = (text, maxLength = 80) => {
    if (!text) return 'No description';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  // ###### RETURN VIEW
  return (
    <div 
      style={props.style}
      className="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-200"
    >
      <div className="p-2">
        
        {/* Header with date, type and value */}
        <div className="flex justify-between items-start mb-1">
          <div className="flex flex-col flex-1">
            {/* Categories */}
            <div className="mb-1">
              <div className="text-xs text-gray-500">
                {props.flow.categ_l1 || 'No category'}
                {props.flow.categ_l2 && (
                  <>
                    <span className="mx-1">|</span>
                    {props.flow.categ_l2}
                  </>
                )}
              </div>
            </div>

            {/* Description */}
            <div>
              <h3 className="text-sm font-medium text-gray-900" title={props.flow.desc}>
                {truncateText(props.flow.desc)}
              </h3>
            </div>
          </div>
          
          <div className="flex flex-col items-end gap-1 ml-4">
            <div className="text-sm text-gray-500" title={props.flow.date || ''}>
              {props.flow.date ? formatDate(props.flow.date, 'display') : '—'}
            </div>
            <div className="flex items-center gap-2">
              <div className={`text-base font-bold ${
                props.flow.flow_type === 'In' ? 'text-green-600' : 'text-red-600'
              }`}>
                {formatValue(props.flow.flow_value)} {props.flow.flow_currency}
              </div>
              <div className={`px-2 py-1 rounded text-xs font-semibold ${getTypeColor()}`}>
                {props.flow.flow_type}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default DetailedTransactionCard; 